import { render, staticRenderFns } from "./the-sidebar.vue?vue&type=template&id=5630b7b0&scoped=true&lang=pug"
import script from "./the-sidebar.js?vue&type=script&lang=js&external"
export * from "./the-sidebar.js?vue&type=script&lang=js&external"
import style0 from "./the-sidebar.vue?vue&type=style&index=0&id=5630b7b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5630b7b0",
  null
  
)

export default component.exports